import { useState, useEffect,useContext } from "react";
import { TableContext } from "../context";
import { McDrawer } from "@maersk-global/mds-react-wrapper/components-core/mc-drawer";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { McLoadingIndicator } from "@maersk-global/mds-react-wrapper/components-core/mc-loading-indicator";
// import { DataGrid } from '@mui/x-data-grid';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Card,
    CardContent,
    Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { McLinkButton } from "@maersk-global/mds-react-wrapper/components-core/mc-link-button";
import { getDateSectionConfigFromFormatToken } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";
import axios from 'axios';

const maerskFontFamily = '"Maersk Text", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft Yahei", "微软雅黑", STXihei, "华文细黑", sans-serif';

function ChangeDetailsDrawer({ isdrawerOpen, setisdrawerOpen, drawerCi, drawerCiCategory, drawerChange }) {
    const [drawerData, setDrawerData] = useState(null);
    const [drawerContent, setDrawerContent] = useState("");
    const [drawerHeading, setDrawerHeading] = useState("");
    const {getToken} = useContext(TableContext);
    const fetchData = async () => {
        setDrawerData(null);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URI}/api/change_data/getChangeDetails`,
                {
                    change_id: drawerChange,
                    app_name: drawerCi,
                },
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                    }
                }
            );
            
            if (response.data?.status === 200) {
                const data = response.data
                console.log("Change Details: ", response.data);
                setDrawerData(response.data);
                setDrawerHeading('Change Details');
                setDrawerContent(
                    <div style={{ display: "flex", flexDirection: "column", padding: "4px" }}>
                        {/* Render Change Number First */}
                        {data.change_details?.change_number && (
                            <div style={{ marginBottom: '20px' }}>
                                <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600", marginBottom: "4px" }}>
                                    Change Number
                                </span>
                                <input
                                    type="text"
                                    value={data.change_details.change_number}
                                    disabled
                                    style={{
                                        fontSize: "1rem",
                                        borderRadius: "8px",
                                        border: "1px solid #e0e0e0",
                                        background: "#f7f7f7",
                                        padding: "8px 12px",
                                        color: "#222",
                                        outline: "none",
                                        width: "100%",
                                        boxSizing: "border-box",
                                        marginTop: "4px"
                                    }}
                                />
                            </div>
                        )}

                        {/* AI Change Analysis Card */}
                        <Card
                            style={{
                                marginBottom: '24px',
                                background: '#E2F3FB',
                                color: 'white',
                                borderRadius: '12px',
                                maxHeight: '300px',
                                display: 'flex',
                                flexDirection: 'column',
                                boxShadow: 'none',
                            }}
                        >
                            <CardContent style={{
                                padding: '16px',
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                                overflow: 'hidden'
                            }}>
                                <Box style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', flexShrink: 0 }}>
                                    <AutoAwesomeIcon
                                        style={{
                                            marginRight: '8px',
                                            fontSize: '20px',
                                            color: '#545454'
                                        }}
                                    />
                                    <Typography
                                        // variant="h6"
                                        style={{
                                            fontWeight: '600',
                                            color: '#545454',
                                            margin: 0,
                                            fontFamily: maerskFontFamily
                                        }}
                                    >
                                        AI Analysis
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    style={{
                                        color: '#141414',
                                        lineHeight: '1.6',
                                        whiteSpace: 'pre-wrap',
                                        fontSize: '0.9rem',
                                        overflowY: 'auto',
                                        flex: 1,
                                        paddingRight: '8px',
                                        minHeight: 0,
                                        fontFamily: maerskFontFamily
                                    }}
                                >
                                    {(() => {
                                        const aiAnalysis = data.change_details?.ai_change_analysis;
                                        if (!aiAnalysis) return 'No AI Analysis Available';

                                        const lines = aiAnalysis.split('\n');
                                        // Remove first line if it contains "=== AI CHANGE MANAGER REVIEW ===" 
                                        // and last line if it contains "--- End of AI Review ---"
                                        const filteredLines = lines.filter((line, index) => {
                                            const isFirstLine = index === 0 && line.includes('=== AI CHANGE MANAGER REVIEW ===');
                                            const isLastLine = index === lines.length - 1 && line.includes('--- End of AI Review ---');
                                            return !isFirstLine && !isLastLine;
                                        });

                                        return filteredLines.join('\n').trim();
                                    })()}
                                </Typography>
                            </CardContent>
                        </Card>

                        {/* Render Other Change Details */}
                        <div style={{ display: "flex", flexWrap: "wrap", }}>
                            {data.change_details &&
                                Object.entries(data.change_details)
                                    .filter(([key]) => key !== 'change_number' && key !== 'ai_change_analysis')
                                    .map(([key, value]) => {
                                        // Remove leading 'u_' or 'U_' if present
                                        let displayKey = key.replace(/^u_/i, '');
                                        displayKey = displayKey.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                                        const stringValue = value !== "" && value !== null ? value.toString() : "NA";
                                        const isLong = stringValue.length > 40;
                                        return (
                                            <div key={key} style={{ minWidth: 220, marginBottom: '20px', flex: '1 1 220px' }}>
                                                <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600", marginBottom: "4px" }}>
                                                    {displayKey}
                                                </span>
                                                {isLong ? (
                                                    <textarea
                                                        value={stringValue}
                                                        disabled
                                                        rows={Math.min(6, Math.ceil(stringValue.length / 40))}
                                                        style={{
                                                            fontSize: "1rem",
                                                            borderRadius: "8px",
                                                            border: "1px solid #e0e0e0",
                                                            background: "#f7f7f7",
                                                            padding: "8px 12px",
                                                            color: "#222",
                                                            outline: "none",
                                                            width: "100%",
                                                            boxSizing: "border-box",
                                                            resize: "vertical",
                                                            marginTop: "4px"
                                                        }}
                                                    />
                                                ) : (
                                                    <input
                                                        type="text"
                                                        value={stringValue}
                                                        disabled
                                                        style={{
                                                            fontSize: "1rem",
                                                            borderRadius: "8px",
                                                            border: "1px solid #e0e0e0",
                                                            background: "#f7f7f7",
                                                            padding: "8px 12px",
                                                            color: "#222",
                                                            outline: "none",
                                                            width: "100%",
                                                            boxSizing: "border-box",
                                                            marginTop: "4px"
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                        </div>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Affected CIs</Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                style={{
                                    maxWidth: "100%",
                                    overflowX: "auto",
                                    padding: 0
                                }}
                            >
                                {data.affected_cis && data.affected_cis.length > 0 ? (
                                    <div style={{ width: "100%" }}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ whiteSpace: "normal", wordBreak: "break-word", maxWidth: 100 }}>CI Name</TableCell>
                                                    <TableCell style={{ whiteSpace: "normal", wordBreak: "break-word" }}>Class Name</TableCell>
                                                    <TableCell style={{ whiteSpace: "normal", wordBreak: "break-word" }}>Environment</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data.affected_cis.map((ci, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{ci.ci_name}</TableCell>
                                                        <TableCell style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{ci.ci_sys_class_name}</TableCell>
                                                        <TableCell style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{ci.ci_environment}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                ) : (
                                    <Typography style={{ padding: '20px' }}>There are no affected CIs</Typography>
                                )}
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Upstream Apps</Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{ maxWidth: "100%", overflowX: "auto", padding: 0 }}>
                                <div style={{ width: "100%" }}>
                                    <ul style={{
                                        paddingLeft: 24,
                                        marginTop: 0,
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                        listStylePosition: "inside"
                                    }}>
                                        {data.upstream_apps && data.upstream_apps.length > 0 ? (
                                            data.upstream_apps.map((app, idx) => (
                                                <li
                                                    key={idx}
                                                    style={{
                                                        wordBreak: "break-word",
                                                        whiteSpace: "normal",
                                                        overflowWrap: "break-word"
                                                    }}
                                                >
                                                    {app}
                                                </li>
                                            ))
                                        ) : (
                                            <li>No upstream apps</li>
                                        )}
                                    </ul>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Downstream Apps</Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{ maxWidth: "100%", overflowX: "auto", padding: 0 }}>
                                <div style={{ width: "100%" }}>
                                    <ul style={{
                                        paddingLeft: 24,
                                        marginTop: 0,
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                        listStylePosition: "inside"
                                    }}>
                                        {data.downstream_apps && data.downstream_apps.length > 0 ? (
                                            data.downstream_apps.map((app, idx) => (
                                                <li
                                                    key={idx}
                                                    style={{
                                                        wordBreak: "break-word",
                                                        whiteSpace: "normal",
                                                        overflowWrap: "break-word"
                                                    }}
                                                >
                                                    {app}
                                                </li>
                                            ))
                                        ) : (
                                            <li>No downstream apps</li>
                                        )}
                                    </ul>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Upstream Changes</Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                style={{
                                    maxWidth: "100%",
                                    overflowX: "auto",
                                    padding: 0
                                }}
                            >
                                {data.upstream_changes && data.upstream_changes.length > 0 ? (
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Change Number</TableCell>
                                                <TableCell>CI Name</TableCell>
                                                <TableCell>Short Description</TableCell>
                                                <TableCell>Start Date</TableCell>
                                                <TableCell>End Date</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.upstream_changes.map((chg, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{chg.change_number}</TableCell>
                                                    <TableCell>{chg.cmdb_ci}</TableCell>
                                                    <TableCell>{chg.short_description}</TableCell>
                                                    <TableCell>{chg.start_date}</TableCell>
                                                    <TableCell>{chg.end_date}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                ) : (
                                    <Typography style={{ padding: '20px' }}>No upstream changes</Typography>
                                )}
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>Downstream Changes</Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                style={{
                                    maxWidth: "100%",
                                    overflowX: "auto",
                                    padding: 0
                                }}
                            >
                                {data.downstream_changes && data.downstream_changes.length > 0 ? (
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Change Number</TableCell>
                                                <TableCell>CI Name</TableCell>
                                                <TableCell>Short Description</TableCell>
                                                <TableCell>Start Date</TableCell>
                                                <TableCell>End Date</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.downstream_changes.map((chg, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{chg.change_number}</TableCell>
                                                    <TableCell>{chg.cmdb_ci}</TableCell>
                                                    <TableCell>{chg.short_description}</TableCell>
                                                    <TableCell>{chg.start_date}</TableCell>
                                                    <TableCell>{chg.end_date}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                ) : (
                                    <Typography style={{ padding: '20px' }}>No downstream changes</Typography>
                                )}
                            </AccordionDetails>
                        </Accordion>

                    </div>
                );
            } else if (response.data?.message?.includes("No change data found")) {
                console.log("No details found for this Change");
                setDrawerData(["No details found for this Change"]);
                setDrawerHeading('Change Details');
                setDrawerContent(
                    <span>
                        No details found for this Change
                    </span>
                );
            } else {
                console.error('Failed to fetch Change details');
                toast.error("Failed to fetch Change details", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setDrawerHeading('Change Details');
                setDrawerContent(
                    <span>
                        No details found for this Change
                    </span>
                );
                setDrawerData(["No details found for this Change"]);
            }
        } catch (error) {
            console.error("Error fetching Change details", error);
            setDrawerData(["No details found for this Change"]);
            toast.error("Error fetching Change details", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setDrawerHeading('Change Details');
            setDrawerContent(
                <span>
                    No details found for this Change
                </span>
            );
        }
    };

    const handleDrawerClose = () => {
        setisdrawerOpen(false);
        setDrawerContent("");
        setDrawerHeading("");
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <McDrawer
                open={isdrawerOpen}
                closed={handleDrawerClose}
            >
                <span slot="heading">
                    {drawerHeading}
                </span>

                {drawerData == null ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <McLoadingIndicator appearance="primary"></McLoadingIndicator>
                    </div>
                ) : (
                    <>
                        <div style={{ marginTop: "10px" }}>{drawerContent}</div>
                        {/* <McButton
                            slot="footer"
                            dialogaction="close"
                            onClick={handleDrawerClose}
                        >
                            Close
                        </McButton> */}
                        <McLinkButton
                            slot="footer"
                            appearance="primary"
                            href={`https://maersk.service-now.com/nav_to.do?uri=change_request.do?sysparm_query=number=${drawerChange}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={() => { /* TODO: Add your full details handler here */ }}
                        >
                            <span style={{ display: "flex", alignItems: "center" }}>
                                Full Details
                                <span style={{ marginLeft: 6 }}>
                                    <mc-icon icon="square-arrow-up-right" size="20" color="white"></mc-icon>
                                </span>
                            </span>
                        </McLinkButton>
                    </>
                )}
            </McDrawer>

        </div>
    );
}

export default ChangeDetailsDrawer;